import { motion } from "motion/react";

interface Stat {
  label: string;
  value: number;
}

interface StatsBarProps {
  stats: Stat[];
}

export function StatsBar({ stats }: StatsBarProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      // 2×2 grid on phones so nothing wraps to an orphaned line; an inline
      // row on ≥sm where all four comfortably fit.
      className="grid grid-cols-2 gap-x-5 gap-y-2.5 sm:flex sm:items-center sm:gap-6 sm:flex-wrap"
    >
      {stats.map((stat) => (
        <div key={stat.label} className="flex items-baseline gap-1.5">
          <span className="text-accent" style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: "0.95rem" }}>
            {stat.value}
          </span>
          <span className="text-muted-foreground" style={{ fontSize: "0.82rem" }}>
            {stat.label}
          </span>
        </div>
      ))}
    </motion.div>
  );
}
